import ReactRailsUJS from "react_ujs";

import "javascripts/application";
import "javascripts/partials/users/clipboard";
import "stylesheets/users";

var componentRequireContext = require.context("components", true);
ReactRailsUJS.useContext(componentRequireContext);

require.context("../images", true, /\.(png|jpg|jpeg|svg)$/);
